export const NavbarDetail1 = [
  {
    labels: "Do more, Be More  | ",
  },
  {
    labels: "Try in 3D  | ",
  },
  {
    labels: "Store Locator  | ",
  },
  {
    labels: "Quality  | ",
  },
  {
    labels: "USA  | ",
  },
  {
    labels: "Singapore  | ",
  },
  {
    labels: "UAE  | ",
  },
  {
    labels: "John Jacobs  | ",
  },
  {
    labels: "Aqualens  | ",
  },
  {
    labels: "Cobrowsing  | ",
  },
  {
    labels: "Engineering Blog  | ",
  },
  {
    labels: "Lenskart Franchise  | ",
  },
  {
    labels: "Contact us",
  },
];

export const NavbarDetail2 = [
  {
    labels: "EYEGLASSES",
  },
  {
    labels: "COMPUTER GLASSES",
  },
  {
    labels: "KID GLASSES",
  },
  {
    labels: "CONTACT LENSES",
  },
  {
    labels: "SUNGLASSES",
  },
  {
    labels: "HOME EYE-TEST",
  },
  {
    labels: "STOTE LOCATOR",
  },
];
